import styled, { css } from 'styled-components';
import cssKit from '../../css'; //eslint-disable-line

const nissan = process.env.BRAND_NAME === 'nissan';

export const StyledVehicleBoxImage = styled.img`
  ${!nissan && css`
    padding: 0 .625rem;
    max-width: 100%;
  `}
`;



/** WEBPACK FOOTER **
 ** ./src/components/VehicleImage/styles.js
 **/